"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SELECTED_CONTRACT = void 0;
exports.default = reducer;
exports.loadContractAccountsAction = loadContractAccountsAction;
exports.setSelectedContractAccountAction = setSelectedContractAccountAction;
exports.setSelectedContractAccountWithoutHashAction = setSelectedContractAccountWithoutHashAction;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _contractApi = require("../../api-factory/contractApi");
var _Router = _interopRequireDefault(require("../../utils/Router"));
var _SessionHandler = _interopRequireDefault(require("../utils/SessionHandler"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT_CONTRACTS = 'api/reducer/GET_CONTRACTS';
var SET_SELECTED_CONTRACT = exports.SET_SELECTED_CONTRACT = 'api/reducer/SET_SELECTED_CONTRACT';
var SET_CONTRACT_WITHOUT_HASH = 'api/reducer/SET_CONTRACT_WITHOUT_HASH';
var SET_API_ERROR = 'api/reducer/SET_API_ERROR';

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getPreselectedContract = function getPreselectedContract(contracts) {
    var id = _Router.default.getParameter('contractAccId');
    if (id) {
      _SessionHandler.default.setPermissions(action.contractAccounts, id);
      return id;
    }
    if (contracts && contracts[0]) {
      _SessionHandler.default.setPermissions(action.contractAccounts, contracts[0].contractAccountId);
      return contracts[0].contractAccountId;
    }
    return null;
  };
  switch (action.type) {
    case LOAD_CURRENT_CONTRACTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.contractAccounts,
        contractId: getPreselectedContract(action.contractAccounts),
        apiError: false,
        apiErrorMessage: ''
      });
    case SET_SELECTED_CONTRACT:
      _SessionHandler.default.setPermissions(state.data, action.selectedContractId);
      _Router.default.setParameter({
        contractAccId: action.selectedContractId
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        contractId: action.selectedContractId
      });
    case SET_CONTRACT_WITHOUT_HASH:
      _SessionHandler.default.setPermissions(state.data, action.selectedContractId);
      return _objectSpread(_objectSpread({}, state), {}, {
        contractId: action.selectedContractId
      });
    case SET_API_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        apiError: true,
        apiErrorMessage: action.apiErrorMessage
      });
    default:
      return state;
  }
}

// Action Creators
// TODO: Add error handling
function loadContractAccountsAction(dispatch) {
  var resp = (0, _contractApi.getContracts)();
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT_CONTRACTS,
      contractAccounts: reponse.data.content
    });
  }).catch(function (error) {
    dispatch({
      type: SET_API_ERROR,
      apiErrorMessage: error.message
    });
  });
}
function setSelectedContractAccountAction(dispatch, contractId) {
  _SessionHandler.default.resetPermissions();
  dispatch({
    type: SET_SELECTED_CONTRACT,
    selectedContractId: contractId
  });
}
function setSelectedContractAccountWithoutHashAction(dispatch, contractId) {
  _SessionHandler.default.resetPermissions();
  dispatch({
    type: SET_CONTRACT_WITHOUT_HASH,
    selectedContractId: contractId
  });
}